export function getSubdomain() {
  const parts = window.location.hostname.split('.');
  return parts.length > 1 ? parts[0] : null;
}

export const formatter = new Intl.NumberFormat('en-CA', {
style: 'currency',
currency: 'CAD',
});

export const formatPercentage = (value) => {
if (!value && value !== 0) return '0.00%';
return `${Number(value).toFixed(2)}%`;
};

export const downloadPdfFromBase64 = (base64Data, fileName) => {
try {
  // Convert base64 to binary
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);
  
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  
  // Create blob
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: 'application/pdf' });
  
  // Download
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  
  document.body.appendChild(a);
  a.click();
  
  // Cleanup
  setTimeout(() => {
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }, 100);
  
  return true;
} catch (error) {
  console.error('Error downloading PDF:', error);
  return false;
}
};